module.exports = __webpack_public_path__ + "img/blog-grid-sidebar.ba9c3618.png";